export default function addExplicitMultiplicationAfterBracket(
  expression: string
): string {
  return expression.replace(/(\))(\w|\()/g, "$1*$2");
}
